﻿{
  "boardmakerHome": "Boardmaker Home",
  "subscription": "Подписка",
  "change": "Изменить",
  "currency": "USD",
  "save": "Сохранить",
  "save17Percent": "<strong>Экономия {{percent}}%</strong> при годовом плане",
  "save17PercentNoBold": "Экономия {{percent}}%",
  "yearly": "Годовой",
  "monthly": "Месячный",
  "Lifetime": "Пожизненно",
  "PerMonth": "В месяц",
  "PerYear": "В год",
  "Free": "Бесплатно",
  "optional": "дополнительно",
  "trialLengthTrial": "<0>{{ trialLength }}</0>-дневный пробный период",
  "viewAllPlans": "Посмотреть все планы",
  "myBoardmaker": "My Boardmaker",
  "canada": "Канада",
  "unitedStates": "Соединенные Штаты",
  "oneMomentPlease": "Одну минуту, пожалуйста...",
  "software": "Программное обеспечение",
  "boardmakerStudio": "Boardmaker Studio",
  "boardmakerStudentCenter": "Boardmaker Student Center",
  "complete": "Завершено",
  "loadingRegions": "Загрузка доступных регионов",
  "loadingPartners": "Загрузка доступных партнеров",
  "supportedPeripherals": "Поддерживаемые периферийные устройства",
  "pleaseWait": "Пожалуйста, подождите ...",
  "minimum": "Минимально",
  "recommended": "Рекомендовано",
  "browser": "Браузер",
  "tobiiDynavoxEyeTrackers": "Устройства Tobii Dynavox Eye Tracker",
  "boardmaker7": "Boardmaker 7",
  "needHelpChoosing": "нужна помощь при выборе",
  "or": "или",
  "advantages": "Преимущества",
  "visitPartnerSite": "Посетите партнерский сайт",
  "recentOrders": "Недавние заказы",
  "current": "текущие",
  "orLater": "или позже",
  "customerSupport": "служба технической поддержки",
  "proratedAmount": "Пропорциональная сумма",
  "community": {
    "community": "Сообщество",
    "getStartedNow": "Начните прямо сейчас!"
  },
  "personal": "Подписка для личного использования",
  "professional": "Подписка для специалистов",
  "planCard": {
    "noCCRequired": "Кредитная карта не требуется",
    "cCOnly": "Только кредитная карта",
    "cCOrPO": "Кредитная карта или заказ на покупку",
    "myPlan": "Мой план",
    "currentPlan": "Текущий план",
    "downgradeNotice": "Изменения вступают в силу по истечении срока действия текущего плана.",
    "upgradeNotice": "Изменения вступают в силу немедленно."
  },
  "selectedPlanSummary": {
    "summary": "Краткий итог",
    "change": "$t(change)",
    "subtotal": "Промежуточный результат"
  },
  "action": {
    "joinToday": "Присоединяйтесь сегодня!",
    "finish": "Закончить",
    "subscribe": "Подписаться",
    "resubscribe": "Переоформить подписку",
    "requestAQuote": "Запросить цену",
    "try": "Испытать программу",
    "startTrial": "Начать пробный период",
    "buyNow": "Купить сейчас",
    "tryIt": "Попробуйте",
    "tryItFree": "Попробуйте бесплатно в течение 30 дней!",
    "free": "бесплатно",
    "getStarted": "Начать работу",
    "forTrialDays": "в течение <1>{{trialLength}}</1> дней",
    "comparePlans": "Сравнить планы",
    "hideComparisons": "Скрыть сравнительную таблицу",
    "learnMore": "Дополнительные сведения",
    "start": "Пуск",
    "next": "Далее",
    "edit": "Редактировать",
    "cancel": "Отменить",
    "imTaxExempt": "Налоговая льгота",
    "submit": "Отправить",
    "print": "Печать",
    "backToPaymentDetails": "Назад к платежным реквизитам",
    "close": "Закрыть",
    "back": "Назад",
    "continue": "Продолжить",
    "uploading": "Идет выгрузка данных на сервер",
    "delete": "Удалить",
    "update": "Обновить",
    "generatingInvoice": "Генерируется счет-фактура",
    "proceed": "Продолжить",
    "modify": "Изменить",
    "yes": "Да",
    "signUp": "Зарегистрироваться",
    "downloads": "Загрузки"
  },
  "status": {
    "loading": "Идет загрузка…",
    "creatingAccount": "Идет создание учетной записи...",
    "submitting": "Идет отправка...",
    "submittingPayment": "Производится платеж...",
    "submittingRequest": "Отправка запроса..."
  },
  "planComparison": {
    "label": "Каковы преимущества каждого плана?",
    "buttonShow": "$t(action.comparePlans)",
    "buttonHide": "$t(action.hideComparisons)",
    "header": "Сравнение характеристик",
    "subheader": "Решение, пользующееся огромной популярностью в мире, для создания бесконечных вариантов коммуникации на базе символов и визуальной поддержки!"
  },
  "account": {
    "email": "Адрес электронной почты",
    "accountFoundTitle": "Найденная учетная запись",
    "accountFoundMessage": "Учетная запись с таким именем уже существует. Вы хотите войти в систему, используя эту учетную запись, либо хотите воспользоваться другим адресом электронной почты и создать новую учетную запись?",
    "signedOutElsewhereTitle": "Вы вышли из системы",
    "signedOutElsewhereMessage": "Вы вышли из системы в другой вкладке. Войдите снова, чтобы продолжить, или закройте это сообщение, чтобы продолжить просмотр без учетной записи.",
    "signedOutElsewhereDismiss": "Продолжить просмотр",
    "federatedEmailTitle": "Обнаружен адрес электронной почты организации",
    "federatedEmailMessage": "Этот адрес электронной почты использует вход через вашу организацию. Войдите, чтобы получить доступ к Boardmaker через организацию, или используйте другой адрес электронной почты, чтобы создать новую учетную запись.",
    "federatedEmailUseDifferent": "Использовать другой адрес",
    "logIn": "Вход в систему",
    "logOut": "Выйти из системы",
    "loggingIn": "Осуществляется вход в систему...",
    "loggingOut": "Осуществляется выход из системы...",
    "verifying": "Идет проверка...",
    "loggingInMessage": "Осуществляется вход в....",
    "createAccount": "Создать учетную запись",
    "creatingAccount": "$t(status.creatingAccount)",
    "login1": "Уже есть учетная запись ",
    "login2": "Tobii",
    "login3": "Dynavox",
    "loginPrompt": "Уже есть <1>учетная запись Tobii Dynavox</1>? <3>Войти</3>",
    "cancelSubscription": "Отменить подписку",
    "areYouSure": "Вы действительно хотите выбрать этот план? Выполнение этого действия приведет к следующему результату:",
    "cancelSubscriptionProcess": "Отменить процесс подписки (ваш текущий прогресс не будет сохранен)",
    "changeToCommunityPlan": "Изменить свою учетную запись на план ''Онлайн-сообщество''",
    "onceYouveCompletedYourProfile": "Если Ваш профиль заполнен и Вы решили изменить свой план, это можно сделать в любое время в разделе ''Моя учетная запись''.",
    "proceed": "$t(action.proceed)",
    "back": "$t(action.back)",
    "loadingUser": "Получение информации о пользователе"
  },
  "requestaquote": {
    "fillOutDetailsBelow": "Пожалуйста, укажите данные ниже, и наш менеджер по работе с клиентами свяжется с Вами в ближайшее время.",
    "fillOutDetailsBelowLicense": "Пожалуйста, укажите данные ниже, и наш продавец-консультант свяжется с Вами в ближайшее время."
  },
  "forms": {
    "confirmEmail": "Подтвердить адрес электронной почты",
    "billingDetails": "Реквизиты для выставление счетов",
    "paymentType": "Тип платежа",
    "creditCardType": "Тип платежа",
    "creditCard": "Кредитная карта",
    "purchaseOrder": "Заказ на покупку",
    "cardNumber": "Номер кредитной карты",
    "expirationDate": "Срок действия",
    "cardholderName": "Имя держателя карты",
    "cardSecurityCode": "Код безопасности карты",
    "securityCode": "Код безопасности",
    "organizationName": "Название организации",
    "accountsPayableEmail": "Электронная почта",
    "firstName": "Имя",
    "lastName": "Фамилия",
    "addressLine": "Адресная строка 1",
    "addressLine2": "Адресная строка 2",
    "country": "Страна",
    "language": "Язык",
    "city": "Город",
    "stateProvinceRegion": "Штат / Область / Район",
    "zipPostalCode": "Почтовый индекс",
    "month": "Месяц",
    "year": "Год",
    "optional": "дополнительно",
    "username": "Имя пользователя",
    "name": "Имя",
    "phoneNumber": "Номер телефона",
    "phone": "Телефон",
    "email": "Адрес электронной почты",
    "url": "URL адрес",
    "selectYourCountry": "Выберите свою страну",
    "selectYourState": "Выберите свой штат",
    "selectYourProvinceTerritory": "Выберите свою провинцию или территорию",
    "selectYourTerm": "Выберите срок",
    "1year": "1 год",
    "2years": "2 года",
    "3years": "3 года",
    "4years": "4 года",
    "5years": "5 лет",
    "instructorLogins": "Количество логинов преподавателя",
    "studentLogins": "Количество логинов учащегося",
    "term": "Срок",
    "tradeIn": "Имеете право на торговую скидку?",
    "legacyVersions": "У Вас есть старые версии Boardmaker, которые можно использовать для получения скидки со стоимости myBoardmaker?",
    "selectAResponse": "Выберите ответ",
    "yes": "Да",
    "no": "Нет",
    "notSure": "Не уверен",
    "password": "Пароль",
    "confirmPassword": "Подтвердить пароль",
    "additionalInformationOrQuestions": "Дополнительная информация или вопросы",
    "countryNotSupported": "---",
    "uploadDocument": "Выгрузить документ",
    "chooseFile": "Выбрать файл",
    "paymentMethod": "Способ оплаты",
    "purchaseOrdersAreOnlyProcessed": "Заказы на покупку обрабатываются только после подачи Вашего заказа, поэтому их можно изменить в любое время до момента подачи.",
    "PONumber": "Номер заказа на покупку",
    "PONotes": "Дополнительная информация",
    "iVerifyThatImAuthorized": "Хочу проверить наличие у меня прав на подачу этого заказа на покупку.",
    "submissionSuccessful": "Заказ принят успешно!",
    "thankYourForYourRequest": "Спасибо за заказ! Наш менеджер по работе с клиентами свяжется с Вами в ближайшее время.",
    "ccExpDateFormat": "MM/YYYY",
    "numberOfLicenses": "Количество лицензий",
    "pleaseEnterYourName": "Введите свое имя в точности так, как оно указано на Вашей кредитной карте.",
    "needHelpFindingSecurityCode": "Где находится код безопасности карты"
  },
  "validation": {
    "required": "Обязательный",
    "invalidEmail": "Недействительный адрес электронной почты",
    "emailsMustMatch": "Адреса электронной почты должны совпадать",
    "passwordsMustMatch": "Пароли должны совпадать",
    "errorOccurred": "При подаче формы произошла ошибка",
    "tryAgain": "Повторите попытку. Если проблема не исчезнет, обратитесь в службу поддержки.",
    "errorOccurredPDF": "При загрузке счета-фактуры в формате PDF произошла ошибка",
    "password": {
      "minLength": "Пароль должен содержать не менее 8 символов",
      "tooShort": "Слишком короткий",
      "checking": "Выполняется проверка…"
    },
    "USZipCode": "Необходимо ввести почтовый индекс США",
    "CAZipCode": "Необходимо ввести почтовый индекс Канады",
    "invalidCardNumber": "Недействительный номер кредитной карты",
    "invalidCardType": "Недействительный тип кредитной карты",
    "invalidExpirationDate": "Неверный срок действия",
    "invalidSecurityCode": "Неверный код безопасности",
    "securityCodeNumericWarning": "Код безопасности должен содержать только цифры",
    "invalidUsernameWarning": "Недействительное имя пользователя. Должен содержать только буквы и цифры.",
    "usernameMaxLengthWarning": "Длина имени пользователя не может превышать 60 символов.",
    "badZip": "Указанный почтовый индекс является недействительным для выбранного штата.",
    "badPostalCode": "Указанный почтовый код является недействительным для выбранной провинции или территории.",
    "canadianAddressNeedsCad": "Для канадских платёжных адресов счета выставляются в канадских долларах. Чтобы продолжить, выберите флаг в верхней части страницы, а затем Канаду."
  },
  "invoice": {
    "communityHeader": "Кредитная карта не требуется. Просто бесплатный доступ к myBoardmaker Community. Если Вы решили перейти на платную подписку, сохраните свои данные и прогресс. Чего Вы ждете?",
    "trialHeader": "Никаких ограничений. Кредитная карта не требуется. Если Вы решили перейти с пробной на платную подписку, сохраните свои данные и прогресс. Чего Вы ждете?",
    "plan": "План",
    "term": "Срок действия",
    "price": "Цена",
    "billingDetails": "$t(forms.billingDetails)",
    "paymentDetails": "Платежные реквизиты",
    "endingWith": "Заканчивается на",
    "expires": "Срок действия истекает",
    "orderSummary": "Сводка по заказу",
    "orderDate": "Дата заказа",
    "orderNumber": "Номер заказа",
    "subtotal": "$t(selectedPlanSummary.subtotal)",
    "tax": "Налог",
    "total": "Итого",
    "aConfirmationEmail": "Электронное письмо с подтверждением заказа было отправлено по адресу",
    "printOrderSummary": "Распечатать сводку по заказу",
    "recurringPaymentDisclaimer": "Ваш заказ предусматривает <strong>периодические платежи</strong> в размере <3>{{amount}}</3>; дата продления - <5>{{date, LL}}</5>.",
    "firstPaymentDisclaimer": "Мы спишем <strong>{{amount}}</strong> <strong>{{date}}</strong>, когда начнётся новая подписка.",
    "PODisclaimer": "Теперь Ваша подписка активна и готова к использованию. Во избежание перебоев в предоставлении технического обслуживания нам необходимо получить Ваш платеж в течение <strong>30 дней</strong>. Если платеж не будет получен до <4>{{date, LL}}</4> , Ваша учетная запись будет переведена в бесплатную учетную запись ''Онлайн-сообщество'' до получения соответствующей суммы.",
    "purchaseOrderNumber": "Номер заказа на покупку",
    "orgNotes": "Дополнительная информация",
    "pleaseSendACopyOfYourInvoice": "Пожалуйста, отправьте свой платеж и копию счета-фактуры по адресу: ",
    "ifYourPurchaseOrdersReady": "Если Ваш заказ на покупку готов, Вы можете отправить его прямо сейчас.",
    "supportedFileTypes": "Поддерживаемые типы файлов: .pdf, .jpg, .jpeg, .tif, .tiff, .png",
    "whenTheTimeComes": " Когда придет время, мы направим Вам письмо по адресу <1>{{email}}</1> с напоминанием о том, когда необходимо произвести следующий платеж.",
    "uploadSuccessful": "Выгрузка завершилась успешно!",
    "yourAccountWillContinue": "Спасибо за Ваш заказ на покупку. При продлении подписки необходимо учитывать тот факт, что срок обработки Вашего заказа может занимать до 14 дней. По завершении процесса Вам будет направлено электронное письмо с подтверждением заказа и счетом-фактурой.",
    "billing": "Адрес для выставления счета",
    "payment": "Способ оплаты",
    "ifYourPurchaseOrderIsReady": "Если Ваш заказ на покупку готов, Вы можете отправить его прямо сейчас.",
    "PODisclaimer1": "Теперь Ваша подписка активна и готова к использованию.",
    "PODisclaimer2": "Платеж должен быть получен в течение 30 дней, в противном случае Ваша учетная запись будет переведена в бесплатную учетную запись ''Онлайн-сообщество''.",
    "POStartsLaterDisclaimer": "Мы отправим счёт <strong>{{date}}</strong>, когда начнётся новая подписка. Оплата должна поступить в течение 30 дней с этой даты."
  },
  "legal": {
    "privacyPolicy": "Политика конфиденциальности",
    "studentPolicy": "Политика в отношении данных учащихся",
    "termsAndConditions": "Условия использования",
    "termsOfService": "Условия предоставления услуг",
    "tdTermsAndConditions": "Я согласен с условиями Tobii Dynavox <1>$t(legal.termsAndConditions)</1>",
    "contactUs": "Свяжитесь с нами"
  },
  "errors": {
    "error": "Ошибка",
    "loadingPlans": "Загрузка планов",
    "sorry": "Извините... это не Ваша вина... это наша ошибка",
    "somethingWentWrong": "Что-то пошло не так на нашей стороне. Мы зафиксировали эту ошибку и, если Вы снова столкнетесь с этой проблемой, мы настоятельно рекомендуем Вам перейти по ссылке <1>{{link}}</1>.",
    "tryGoingBack": "Попробуйте вернуться назад или <1>{{link}}</1>",
    "downloadList": "Не удалось загрузить список загрузок."
  },
  "404": {
    "sorry": "Извините... мы не смогли найти эту страницу",
    "oldLink": "Возможно, эта ссылка устарела или страница была перемещена.",
    "tryGoingBack": "$t(errors.tryGoingBack)"
  },
  "trial": {
    "getStartedNow": "Начните использование бесплатной пробной версии прямо сейчас!",
    "startYourFreeTrial": "Начните использование бесплатной пробной версии",
    "todayWhichIncludesAccessForThirtyDays": " уже сегодня, которое включает в себя доступ в течение 30 дней!"
  },
  "navigation": {
    "bmoRedirect": "Переадресация на myBoardmaker..."
  },
  "expired": {
    "expiredTrialText": "Надеемся, что Вам понравилось 30-дневное неограниченное ознакомление с возможностями программы. Ваша пробная версия была переведена в бесплатную учетную запись ''Онлайн-сообщество'', и все Ваши данные и прогресс* были сохранены. Для получения доступа к премиальным функциям, которые были доступны во время пробного периода, просто перейдите на месячную или годовую подписку.",
    "dataAndProgress": "* Данные и прогресс, содержащиеся в премиальных функциях, доступны только при полностью оплаченной подписке."
  },
  "currencySelector": {
    "header": "Выберите свою страну и язык",
    "disclaimer": {
      "USD": "Если Ваша страна отсутствует в списке, пожалуйста, выберите Соединенные Штаты Америки"
    }
  },
  "taxExempt": {
    "us&ca": "Только Соединенные Штаты и Канада",
    "taxExemptionProgram": "Представьте документы, освобождающие от уплаты налогов, с помощью этой формы. Мы свяжемся с Вами по электронной почте в течение 3 рабочих дней, чтобы подтвердить Ваш статус освобождения от налогов. После получения электронного письма с подтверждением Вы сможете оформить освобожденный от налогов заказ. Если Вы направите заказ до получения электронного письма с подтверждением, с Вас будет взыскан невозмещаемый налог.",
    "taxExemptionProgramExisting": "Представьте документы, освобождающие от уплаты налогов, с помощью этой формы. Мы свяжемся с Вами по электронной почте в течение 3 рабочих дней, чтобы подтвердить Ваш статус освобождения от налогов. После получения электронного письма-подтверждения последующие покупки и продления подписки налогом облагаться не будут. Налоги, уплаченные по покупкам, произведенным до получения электронного письма с подтверждением освобождения от уплаты налогов, не подлежат возврату.",
    "yourSubmissionWasSuccessfulNew": "Заказ принят успешно. Наши сотрудники изучат Вашу документацию, и в течение 3 рабочих дней Вы должны получить по электронной почте уведомление, подтверждающее, что Ваш заказ был обработан. После того, как заказ был одобрен, Вы можете оформить освобождение заказа от уплаты налогов. А пока мы создали для вас бесплатную учетную запись ''Онлайн-сообщество'', таким образом, Вы можете начать изучение функций, предлагаемых программой myBoardmaker.",
    "yourSubmissionWasSuccessfulExisting": "Заказ принят успешно. Наши сотрудники изучат Вашу документацию, и в течение 3 рабочих дней Вы должны получить по электронной почте уведомление, подтверждающее, что Ваш заказ был обработан. После того, как заказ был одобрен, Вы можете оформить освобождение следующего заказа от уплаты налогов."
  },
  "modify": {
    "contactCustomerSupport": "Свяжитесь с <1>{{supportLink}}</1> для изменения подписки",
    "billingDetails": "Изменить реквизиты для выставление счетов",
    "paymentModalHeader": "Обновление завершено успешно!",
    "paymentModalBody": "Изменения будут отражены в следующем цикле выставления счетов.",
    "thankYou": "Спасибо за оплату!",
    "daysRemaining": "дней осталось",
    "dueDisclaimer": "Если платеж не будет получен в течение 30 дней с даты продления, Ваша учетная запись будет автоматически переведена в бесплатную учетную запись ''Онлайн-сообщество'' до получения соответствующей суммы.",
    "lateDisclaimer": "Во избежание прерывания подписки, пожалуйста, оплатите соответствующую сумму в полном объеме. Если платеж не будет получен, Ваша учетная запись будет автоматически переведена в бесплатную учетную запись ''Онлайн-сообщество'' до получения соответствующей суммы.",
    "nextPaymentDueIn": "Следующий платеж - через",
    "days": "дней",
    "paymentIs": "Платеж просрочен на",
    "daysPastDue": "дней",
    "recurringPaymentDisclaimer": "Ваш <1>planOrOrder</1> предусматривает <strong>периодические платежи</strong> в размере <4>{{amount}}</4>; дата продления - <7>{{date, LL}}</7>.",
    "recurringPaymentDisclaimerNoPrice": "Ваш заказ предусматривает <strong>периодические платежи</strong>; дата продления - <3>{{date, LL}}</3>.",
    "pastDueDisclaimer": "Вы можете отправить заказ на покупку одним из способов, описанных ниже. Для повторной активации Вашей подписки свяжитесь с нашей службой технической поддержки.",
    "yourAccountHasBeenConverted": "Ваша платная учетная запись была переведена в бесплатную учетную запись ''Онлайн-сообщество''",
    "balanceDueIn": "Остаток, причитающийся к оплате, через",
    "subscriptionExpiresIn": "Срок действия подписки истекает",
    "paymentPastDue": "Платеж просрочен",
    "autoRenewal": "Автоматическое продление подписки",
    "turnAutoRenewOff": {
      "header": "Отменить автоматическое продление подписки",
      "areYouSure": "Вы действительно хотите отключить автоматическое продление подписки? Выполнение этого действия приведет к следующему результату:",
      "points": [
        "Отменить платную подписку в конце текущего цикла выставления счетов.",
        "Перевести учетную запись в бесплатный план ''Онлайн-сообщество'' в конце текущего цикла выставления счетов.",
        "После перевода Вы будете иметь доступ к своему контенту; для возобновления доступа к премиальным функциям, предлагаемым платной подпиской, Вы в любое время сможете возобновить подписку.  ",
        "Если Вы изменили свое решение до окончания срока действия текущей подписки, Вам достаточно просто включить функцию ''автоматическое продление подписки''."
      ],
      "footer": "Вы хотите отключить автоматическое продление подписки?"
    },
    "turnAutoRenewOn": {
      "header": "Включить автоматическое продление подписки",
      "areYouSure": "Автоматическое продление подписки включает в себя:",
      "points": [
        "Ваша подписка настроена на автоматическое продление по окончании текущего периода подписки.",
        "Удобство платежей с помощью сохраненного способа оплаты.",
        "При каждом продлении подписки Вы будете получать квитанцию по электронной почте.",
        "Как обычно, Вы сможете изменить настройки подписки в любое время в разделе ''Мой план''.",
        "Передумали? Отключите автоматическое продление подписки до конца последнего дня текущего периода подписки, после чего Вам не будут выставляться счета."
      ],
      "footer": "Вы хотите включить автоматическое продление подписки?"
    },
    "on": "Вкл.",
    "off": "Выкл.",
    "pending": "ожидающее",
    "plan": "План",
    "term": "Срок действия",
    "effective": "Вступает в силу",
    "subscription": "Подписка",
    "downgradeWarning": {
      "title": "Понижение категории подписки",
      "prompt": "Вы действительно хотите выбрать этот план? Выполнение этого действия приведет к следующему результату:",
      "planChange": "Понизить категорию своего плана с ''Подписки для специалистов'' на ''Подписку для личного использования'' по окончании текущего цикла выставления счетов.",
      "termChange": "Понизить срок с ''Годовой подписки'' на ''Месячную подписку'' по окончании текущего цикла выставления счетов.",
      "changeNote": "Изменения будут отражены в следующем цикле выставления счетов.",
      "termChangeMultiToYearly": "Понизить срок с ''Многолетней подписки'' на ''Годовую подписку'' по окончании текущего цикла выставления счетов.",
      "termChangeMultiToMonthly": "Понизить срок с ''Многолетней подписки'' на ''Месячную подписку'' по окончании текущего цикла выставления счетов."
    },
    "futureAmendmentThankYou": "Эти изменения вступят в силу в конце текущего цикла выставления счетов. Счет-фактура станет доступной, как только эти изменения будут применены к Вашей учетной записи. Если Вы хотите отменить ожидающее изменение, пожалуйста, позвоните в <1>службу технической поддержки</1>.",
    "futureAmendmentDisclaimer": "Срок действия Вашего текущего плана <1>{{planName}}</1> истекает <3>{{startEndDate}}</3>. Ваш новый план <5>{{selectedPlanName}}</5> активируется <7>{{startEndDate}}</7>; дата автоматического продления - <9>{{term}}</9>.",
    "modificationPending": "Изменение плана в режиме ожидания",
    "paymentDeclined": "Продление подписки было отклонено. Пожалуйста, измените способ оплаты до <1>{{date}}</1>, в противном случае, Ваша подписка будет отменена.",
    "continueSubscription": "Дата окончания срока действия Вашей подписки: <1>{{ date1 }}</1>. Если Вы хотите продлить подписку еще на один срок {{term}},, включите автоматическое продление до <5>{{ date2 }}</5>, и мы обработаем Ваш платеж на следующий день.",
    "discontinuedRatePlan": "Ваш текущий план подписки более не доступен. Пожалуйста, выберите другой вариант.",
    "cancelYourSubscription": "Если Вы хотите отменить свою подписку и получить полный возврат денег, Вам необходимо связаться с <1>{{supportLink}}</1> до <3>{{thirtyDayWindow}}</3>",
    "modifySubscription": "Изменить подписку",
    "cancelCardText": "Вы можете отменить подписку в любое время. Но мы будем рады, если Вы останетесь.",
    "cancelConfirmTitle": "Вы действительно хотите отменить подписку?",
    "cancelConfirmIntro": "Ваш текущий план будет действовать до <strong>{{date}}</strong> После окончания срока действия плана:",
    "cancelConsequences": [
      "Вы потеряете доступ к премиум-функциям.",
      "Вы лишитесь эксклюзивных преимуществ, доступных с подпиской.",
      "Преимущества подписки закончатся, когда истечет срок действия текущего плана."
    ],
    "keepSubscription": "Сохранить мою подписку",
    "confirmCancel": "Нет, я хочу отменить",
    "cancelledTitle": "Ваша подписка отменена!",
    "cancelledBody": "Ваша подписка отменена. После {{date}} у Вас не будет доступа к премиум-аккаунту.",
    "cancelledFarewell": "Нам жаль, что Вы уходите! Вы всегда можете вернуться.",
    "done": "Готово",
    "cancelledNotice": "Срок действия Вашей текущей подписки <strong>{{planName}}</strong> истекает <strong>{{date}}</strong> Продлите подписку, чтобы и дальше пользоваться нашими премиум-функциями.",
    "resubscribedNotice": "Ваша новая подписка <strong>{{planName}}</strong> начнётся <strong>{{date}}</strong>, когда закончится текущая."
  },
  "tdAccount": {
    "title": "Учетная запись Tobii Dynavox",
    "header": "Что такое учетная запись ''Единый вход (SSO) Tobii Dynavox''?",
    "body": "Ваша учетная запись Tobii Dynavox SSO, состоящая из адреса электронной почты и пароля, является единой учетной записью для входа на все наши веб-сайты или приложения. Помимо повышения уровня безопасности, SSO обеспечивает более быстрый и удобный доступ к Вашему контенту во всех сервисах Tobii Dynavox.",
    "haveA": "У Вас есть",
    "tobiiDynavoxAccount": "учетная запись Tobii Dynavox?"
  },
  "redirectPageTitle": {
    "homePage": "Главная страница",
    "profileCreation": "Создание профиля"
  },
  "download": {
    "downloadBoardmaker": "Скачать Boardmaker",
    "downloadBoardmakerStudentCenter": "Скачать Boardmaker Student Center",
    "downloadOtherVersions": "Скачать другие версии",
    "downloadBoardmakerStudio": "Скачать Boardmaker Studio",
    "download": "Скачать",
    "licenseKey": "Лицензионный ключ",
    "licenseHelper": "Управление лицензиями",
    "discontinued": "Прекращено <1>{{discontinueDate}}</1>. См. <3>системные требования</3>.",
    "mainFeatures": "Основные характеристики",
    "compatibility": "Cовместимость",
    "improvements": "Улучшения",
    "bugFixes": "Исправления ошибок",
    "version": "Версия",
    "discontinuedSupport": "Прекращение поддержки",
    "releaseDate": "Выпущено  {{date}}",
    "discontinuedDate": "Прекращено  {{date}}",
    "boardmakerSummary": "Нажмите кнопку ниже для загрузки последней версии Boardmaker Editor, который используется для создания и редактирования заданий.  Установщик работает со всеми типами учетных записей и поддерживаемыми языками.",
    "studentCenterSummary": "Нажмите кнопку ниже для загрузки последней версии Boardmaker Student Center, который используется для воспроизведения заданий  Boardmaker. Установщик работает со всеми типами учетных записей и поддерживаемыми языками.",
    "boardmakerIntro": "Boardmaker 7 Editor - основной инструмент, помогающий педагогам, врачам и родителям создавать, редактировать и делиться заданиями Boardmaker.  Поддерживайте обучение и взаимодействие в классе, терапевтическом кабинете или дома с помощью множества настраиваемых материалов.",
"studentCenterIntro": "При использовании с определенными типами подписок на Boardmaker 7 преподаватели могут назначать задания ученикам в приложении Boardmaker 7 Student Center и отслеживать их прогресс.  Учащиеся могут использовать приложение дома или в школе для выполнения заданий.",
"boardmakerStudioIntro": "Boardmaker Studio позволяет людям, помогающим учащимся с ограниченными возможностями, создавать и редактировать задания, направленные на оказание помощи учащимся в обучении и общении с использованием символов, текста, а также синтетического и записанного голоса.",
"mobilePlayerIntro": "При использовании с определенными типами подписок на myBoardmaker преподаватели могут назначать задания ученикам в приложении Boardmaker Student Center и отслеживать их прогресс.  Учащиеся могут использовать приложение дома или в школе для выполнения заданий.",
    "communityStartHeader": [
      "Получите доступ к Онлайн-сообществу и хранилищу",
      0,
      0
    ],
    "communityStartBody": [
      "Boardmaker предназначен для работы с сайтом Boardmakeronline.com, где Вы можете создавать резервные копии своих личных файлов Boardmaker и взаимодействовать с нашим мировым сообществом. Члены сообщества могут делиться своими созданиями и находить новые задания в рамках Boardmaker путем общения с другими пользователями. Для получения доступа зарегистрируйте бесплатную учетную запись ''Онлайн-сообщество''!",
      0,
      0
    ],
    "latestMobile": "Попробуйте скачать вобравшее в себя передовой опыт программное обеспечение с устройства, соответствующего требованиям <1>{{systemRequirements}}</1>.",
    "downloadSystemRequirements": "системные требования",
    "viewSystemRequirements": "Системные требования см. в разделе <1>{{guideLink}}</1>.",
    "onThisPage": "На этой странице",
    "communityStart": {
      "header": "Получите доступ к Онлайн-сообществу и хранилищу",
      "body": "Boardmaker предназначен для работы с myboardmaker.com. Ваша бесплатная учетная запись Boardmaker Community включает:",
      "pointOne": "Облачное хранилище - Безопасное резервное копирование личных файлов Boardmaker и доступ к ним из любого места!",
      "pointTwo": "Activities-to-Go - Готовая к печати и использованию тематическая учебная программа, разделенная по уровням.",
      "pointThree": "Взаимодействие с нашим мировым онлайн-сообществом - Члены сообщества могут делиться своими созданиями и находить новые задания в рамках Boardmaker путем общения с другими пользователями.",
      "footer": "Для получения доступа зарегистрируйте свою бесплатную учетную запись ''Онлайн-сообщество''!"
    },
    "BoardmakerCompatible": "Это устройство не совместимо с программным обеспечением Boardmaker.",
    "BoardmakerStudentCenterCompatible": "Это устройство не совместимо с приложением Boardmaker Student Center.",
    "BoardmakerMobile": "Приложения Boardmaker не поддерживаются на вашем устройстве."
  },
  "subscriptionLicense": {
    "toggle": {
      "subscription": "подписка",
      "tosubscriptionText": "$t(subscriptionLicense.toggle.subscription)",
      "license": "лицензия",
      "tolicenseText": "разовая покупка",
      "mainText": "Предпочитаете <1>{{ toggleText }}</1> или <3>{{ helpLink }}</3>?",
      "preferencedText": "Предпочитаете "
    },
    "comparison": {
      "accessTo": "Доступ к...",
      "title": "Помогите выбрать",
      "titleDescription": "Краткий обзор различий между подпиской на myBoardmaker и самим программным обеспечением Boardmaker.",
      "titles": {
        "investment": "Инвестиция",
        "includedSoftware": "С программным обеспечением",
        "softwareUpdates": "Обновления программного обеспечения",
        "pcsSymbols": "PCS Symbols",
        "cloudStorage": "Облачное хранилище",
        "curriculum": "Учебная программа",
        "studentManagement": "Контроль учеников"
      },
      "subscription": {
        "header": "Подписка на myBoardmaker",
        "investment": "Низкая предоплата, варианты годовой или ежемесячной оплаты",
        "includedSoftware": "Boardmaker 7, Boardmaker Student Center",
        "softwareUpdates": "Включено (2-3 раза в год)",
        "pcsSymbols": "Все символы, включая новые символы каждые 2 недели",
        "cloudStorage": ["Сведения о заданиях", "Хранилище мультимедиа"],
        "curriculum": [
          "Boardmaker Activities to Go (10 тем x 4 блоков каждая)",
          "Reading Avenue",
          "Core First Learning",
          "Expedition Education",
          "Book Bridge"
        ],
        "studentManagement": [
          "Assign activities\u00B9",
          "Отслеживание выполнения заданий"
        ]
      },
      "license": {
        "header": "Только программное обеспечение",
        "investment": "Разовая покупка программного обеспечения",
        "includedSoftware": "Boardmaker 7",
        "softwareUpdates": "Периодически оплачиваемые обновления (каждые 2-3 года)",
        "pcsSymbols": "Все символы, доступные на момент последнего выпуска (подписка на PCS скоро станет доступной).",
        "cloudStorage": "Сведения о заданиях",
        "curriculum": "Boardmaker Activities to Go (1 тема x 4 блока)",
        "studentManagement": "Отсутствует"
      },
      "note": "Пользователи могут управлять и добавлять назначения индивидуальным студентам в план ''Подписка для специалистов''.",
      "note2": "Доступно только для плейера Student Center.",
      "note3": "Пользователи могут управлять и добавлять назначения индивидуальным студентам в план ''Подписка для специалистов''.",
      "localizationNoteOne": "Приложения Boardmaker 7 поддерживает следующие языки как для подписчиков, так и пользователей бессрочных подписок (только для программного обеспечения)",
      "availableIn": [
        "Dansk",
        "Deutsch",
        "English (US)",
        "Español",
        "Suomi",
        "Français",
        "Italiano",
        "Norsk",
        "Polski",
        "Português (Brasil)",
        "Русский",
        "Svenska"
      ],
      "oldAvailableIn": [
        "Английский (США)",
        "Испанский",
        "Немецкий",
        "Шведский",
        "Финский",
        "Русский",
        "Датский",
        "Норвежский",
        "Французский",
        "Итальянский",
        "Польский",
        "Португальский"
      ],
      "localizationNoteTwo": "Учебная программа и сайт myBoardmaker.com доступны только на английском языке."
    }
  },
  "systemRequirements": "Системные требования",
  "releaseNotes": "Примечания к выпуску", 
  "operatingSystem": {
    "title": "Операционная система",
    "macos": "macOS",
    "chromebook": "Chromebook",
    "ios": "iPadOS",
    "android": "Android (mobile)",
    "windows": "Windows",
    "unknown": "Неизвестно"
  },
  "perpetual": {
    "trial": {
      "intro": "Кредитная карта не требуется. Никаких обязательств. Всего <1>{{trialLength}}</1> календарных дней неограниченного доступа к нашему последнему программному обеспечению Boardmaker. После загрузки и установки программного обеспечения на Ваш компьютер, Вы можете запросить ключ активации на <3>{{trialLength}}</3> дней<5>*</5> из программы.",
      "footnote": "<0>*</0>Испытательный период начинается в день активации нашего программного обеспечения и действует в течение <2>{{trialLength}}</2> календарных дней.",
      "downloadFootnote": "<0>v{{version}}</0> включает в себя новейшие функции и исправления. См. <2>системные требования</2>."
    },
    "thankyou": {
      "intro": "Найдите электронное письмо с подтверждением заказа, содержащее ссылки на загрузку Boardmaker и ключ активации. Кроме того, ознакомьтесь с информацией ниже. Скачайте и установите Boardmaker на свой компьютер, а затем активируйте программу с помощью ключа активации. После активации Вы будете бесплатно получать обновления в течение 1 года. <1>Сохраните ключ активации для последующего использования.</1>"
    },
    "latest": "Последняя версия",
    "legacy": "Старая версия"
  },
  "countries": {
    "us": "Соединенные Штаты Америки"
  },
  "currencyChange": {
    "header": "Смена валюты",
    "body": "В настоящее время подписку нельзя приобрести в валюте выбранной Вами страны. Если Вы решили продолжить, валюта будет изменена на доллары США - USD."
  },
  "partner": {
    "body": "Выбранный партнер или поставщик технической поддержки будет Вашим основным контактным лицом по всем вопросам, связанным с продуктами и техническим вопросам.",
    "contactUs": "Если страна указана в списке неправильно, пожалуйста ",
    "contactCustomerService": "свяжитесь со службой технической поддержки."
  }
}
